import React from "react";

const FormsDivider = ({ title }) => {
  return (
    <div
      style={{
        height: "1.3em",
        margin: "0.5em 0",
        border: "1px dashed blue",
        borderTop: 0,
        borderRight: 0,
        borderLeft: 0,
      }}
    >
      {title}
    </div>
  );
};

export default FormsDivider;
